import { message } from 'antd';
import FileSaver from 'file-saver';
import { AppInsights } from "applicationinsights-js";

import * as t from './actionTypes';
import * as constants from './constants';
import common from '../../common';
import uistate from '../uistate';

//#region Companies

export function loadCompaniesHierarchy() {
    return async (dispatch) => {
        const resp = await common.apiClient.get(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/companies/hierarchy`);
        dispatch({
            type: t.LOAD_COMPANIES,
            payload: resp.data
        })
    };
}
